
import logo from 'images/logo-footer.png';
import * as S from './styles';

function Footer() {
  return (
    <S.Wrapper>
      <S.Container>
        <a href="https://stmforum.com" target="blank">
          <img className="logo-footer" src={logo} alt="" />
        </a>
        <aside>
          <a href="https://stmforum.com" target="blank">
            <h4>What's STM Forum?</h4>
          </a>
          <hr />
          <ul>
            © 2022 STM Forum               
            <li>
              <a href="https://stmforum.com/blog" target="blank">
                STM Blogs
              </a>
            </li>
            <li>
              <a href="https://stmforum.com/privacy.html" target="blank">
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="https://stmforum.com/customer_tos.html" target="_blank" rel="noopener noreferrer">
                Terms Of Service
              </a>
            </li>
            <li>
              <a href="https://stmforum.com/earnings-disclaimer.html" target="blank">
                Disclaimer
              </a>
            </li>
          </ul>
        </aside>
      </S.Container>
    </S.Wrapper>
  );
}

export default Footer;
